import React, { PropsWithChildren, ReactNode, useMemo } from 'react'
import { connect } from 'react-redux'

interface MappedStateProps {
  businessAccount?: App.BusinessTraveller.CurrentBusinessAccount
}
interface Props {
  employeeRoles?: Array<App.BusinessTraveller.EmployeeRole>
  loading?: ReactNode
  fallback?: ReactNode
}

function BusinessTravellerAccountGuard(props: PropsWithChildren<Props & MappedStateProps>) {
  const {
    employeeRoles: employeeRole,
    children,
    businessAccount,
    fallback,
    loading,
  } = props

  const shouldLetIn = useMemo(() => {
    const allowedRole = !employeeRole ? true :
        businessAccount?.employee?.roles.some(role => employeeRole.includes(role))

    return allowedRole
  }, [employeeRole, businessAccount])

  if (!businessAccount || businessAccount.status === 'pending') {
    return <>{loading}</>
  }

  if (!shouldLetIn || businessAccount.status === 'failed') {
    return <>{fallback}</>
  }

  return <>{children}</>
}

export default connect<MappedStateProps, undefined, Props, App.State>((state) => {
  return {
    businessAccount: state.businessTraveller.currentBusinessAccount,
  }
})(BusinessTravellerAccountGuard)
